__turbopack_context__.v({
  "container": "why-section-module-scss-module__OtB1zG__container",
  "title": "why-section-module-scss-module__OtB1zG__title",
});
